var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCssIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FLASK MEDICAL REPORT") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.737,
    y: 15.154,
    width: 84.527,
    height: 106.539,
    rx: 5,
    fill: "#9b8e99"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.806,
    y: 25.223,
    width: 64.389,
    height: 86.401,
    fill: "#dff6fd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.388 47.481 67.076 47.481 67.076 41.169 60.924 41.169 60.924 47.481 54.612 47.481 54.612 53.634 60.924 53.634 60.924 59.946 67.076 59.946 67.076 53.634 73.388 53.634 73.388 47.481",
    fill: "#f07281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.188,15.154V26.679a2,2,0,0,1-2,2H51.812a2,2,0,0,1-2-2V15.154Z",
    fill: "#fee45a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.094,
    y: 6.307,
    width: 21.811,
    height: 8.847,
    fill: "#fedf30"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.264,39.37a1.75,1.75,0,0,0-1.75,1.75v4.5a1.75,1.75,0,1,0,3.5,0v-4.5A1.751,1.751,0,0,0,106.264,39.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.264,13.4H76.655v-7.1a1.75,1.75,0,0,0-1.75-1.75H53.1a1.75,1.75,0,0,0-1.75,1.75v7.1H26.736a6.758,6.758,0,0,0-6.75,6.75V92.715a1.75,1.75,0,0,0,3.5,0V20.154a3.254,3.254,0,0,1,3.25-3.25H48.062v6.569H31.806a1.749,1.749,0,0,0-1.75,1.75v86.4a1.75,1.75,0,0,0,1.75,1.75H96.194a1.75,1.75,0,0,0,1.75-1.75v-86.4a1.749,1.749,0,0,0-1.75-1.75H79.937V16.9h21.327a3.254,3.254,0,0,1,3.25,3.25V31.463a1.75,1.75,0,1,0,3.5,0V20.154A6.758,6.758,0,0,0,101.264,13.4ZM54.845,8.057h18.31V13.4H54.845Zm39.6,101.817H33.556v-82.9H48.092a3.744,3.744,0,0,0,3.72,3.456H76.187a3.744,3.744,0,0,0,3.721-3.456H94.444ZM76.437,26.679a.25.25,0,0,1-.25.25H51.812a.251.251,0,0,1-.25-.25V16.9H76.437Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.264,53.106a1.75,1.75,0,0,0-1.75,1.75v61.837a3.254,3.254,0,0,1-3.25,3.25H26.736a3.254,3.254,0,0,1-3.25-3.25V102.078a1.75,1.75,0,0,0-3.5,0v14.615a6.758,6.758,0,0,0,6.75,6.75h74.528a6.758,6.758,0,0,0,6.75-6.75V54.856A1.751,1.751,0,0,0,106.264,53.106Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.611,55.384h4.563v4.562a1.75,1.75,0,0,0,1.75,1.75h6.152a1.75,1.75,0,0,0,1.75-1.75V55.384h4.563a1.751,1.751,0,0,0,1.75-1.75V47.481a1.751,1.751,0,0,0-1.75-1.75H68.826V41.169a1.75,1.75,0,0,0-1.75-1.75H60.924a1.75,1.75,0,0,0-1.75,1.75v4.562H54.611a1.75,1.75,0,0,0-1.75,1.75v6.153A1.75,1.75,0,0,0,54.611,55.384Zm1.75-6.153h4.563a1.75,1.75,0,0,0,1.75-1.75V42.919h2.652v4.562a1.75,1.75,0,0,0,1.75,1.75h4.563v2.653H67.076a1.749,1.749,0,0,0-1.75,1.75V58.2H62.674V53.634a1.749,1.749,0,0,0-1.75-1.75H56.361Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3,67.993a1.75,1.75,0,0,0,0,3.5H83.7a1.75,1.75,0,1,0,0-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7,87.587H44.3a1.75,1.75,0,0,0,0,3.5H83.7a1.75,1.75,0,0,0,0-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7,77.79H44.3a1.75,1.75,0,0,0,0,3.5H83.7a1.75,1.75,0,0,0,0-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,97.384H44.3a1.75,1.75,0,0,0,0,3.5H64a1.75,1.75,0,0,0,0-3.5Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssIcon);
export default __webpack_public_path__ + "static/media/css-icon.54472be66dfbbf7e505fd506f8f24b0c.svg";
export { ForwardRef as ReactComponent };